import { UserModel } from "model/User.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = UserModel | null;

export const useDefaultObservableUserModelNull = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectUserModelNull extends BehaviorSubject<CurrentType> {}
